export default {
  methods: {
    $deletePromoCode (promoCodeId) {
      this.$store.dispatch('delete_promo_code', promoCodeId)
    }
  },
  computed: {
    $allPromoCodes: function () {
      return this.$store.state.PromoCodeStore.all_promo_codes
    },
    $allPromoCodesActive: function () {
      return this.$store.state.PromoCodeStore.promo_codes
    },
    promoCode: function () {

      return this.$store.state.PromoCodeStore.promo_code[0]
    },
    updatePromoCode: function () {
      this.promo_code.start_date = this.promoCode.start_date
      this.promo_code.end_date = this.promoCode.end_date
      this.promo_code.percentage_off = this.promoCode.percentage_off
      this.promo_code.max_uses = this.promoCode.max_uses
    },
    promoCodeUsage: function () {
      return this.$store.state.PromoCodeStore.promo_code_usage
    }
  }
}
